import { t } from "../core/i18n.js";
import { icon } from "./icons.js";
import { pomodoroArt } from "./pomodoro-art.js";
import { productShowcase } from "./landing-product-demos.js";

export const demoCursor = `<span class="demo-cursor" aria-hidden="true"><svg viewBox="0 0 28 36" fill="none"><path d="M3 2v27l7-7 5 12 5-2-5-12h10L3 2Z" fill="#252525" stroke="white" stroke-width="2.2" stroke-linejoin="round"/></svg></span>`;

const demoRows = (names) =>
  names
    .map(
      (name) =>
        `<div class="tour-routine-row"><span>${icon("check")}</span><b>${t(name)}</b></div>`,
    )
    .join("");
function tourScene(kind) {
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  if (kind === "rhythm")
    return `<div class="tour-window-head">${icon("manage")}<span>${t("Different day groups")}</span><i></i></div><div class="tour-rhythm-body"><div class="tour-day-picker">${days.map((day, i) => `<span data-tour-day="${i}">${t(day)}</span>`).join("")}</div><div class="tour-group-label"><b data-tour-group>${t("My workdays")}</b><small data-tour-days>${t("Mon")} · ${t("Wed")} · ${t("Fri")}</small></div><div data-tour-routine="work">${demoRows(["Wake up early", "Focus on important work", "Learn something new"])}</div><div data-tour-routine="rest" hidden>${demoRows(["Go for a run", "Spend time with family", "Plan tomorrow"])}</div></div>`;
  if (kind === "table")
    return `<div class="tour-window-head">${icon("table")}<span>${t("30-day plan table")}</span><small>${t("Week view")}</small></div><div class="tour-table-wrap"><div class="tour-table"><span class="tour-table-label">${t("Plan")}</span>${days.map((day) => `<span class="tour-table-day">${t(day)}</span>`).join("")}${["Go for a run", "Learn something new", "Focus on important work"].map((name, row) => `<span class="tour-table-label">${t(name)}</span>${days.map((_, column) => `<span class="tour-table-cell" data-tour-cell="${row * 7 + column}">${icon("check")}</span>`).join("")}`).join("")}</div><div class="tour-table-footer"><span>${t("Small steps add up.")}</span><b data-tour-total>0 / 21</b></div></div>`;
  if (kind === "floating")
    return `<div class="tour-window-head">${icon("pomodoro")}<span>${t("Focus beyond your browser.")}</span><i></i></div><div class="tour-desktop"><div class="tour-work-document"><span>${t("Your next idea")}</span><i></i><i></i><i></i><div></div><i></i><i></i></div><span class="tour-open-mini" data-tour-open>${icon("popout")} ${t("Mini timer")}</span><div class="tour-mini"><div class="tour-mini-head"><b>DayX</b><span data-tour-hide>${icon("eye-off")}</span></div><div class="tour-mini-clock"><b data-demo-time>25:00</b><small>${t("FOCUS TIME")}</small></div><div class="tour-mini-art" hidden>${pomodoroArt()}<small>${t("Stay focused.")}</small></div><div class="tour-mini-controls">${icon("pause")}<span>${t("Current block")} 1 / 8</span>${icon("reset")}</div></div></div>`;
  return `<div class="tour-window-head">${icon("exams")}<span>${t("Exams")}</span><i></i></div><div class="tour-exam-body"><div class="tour-exam-input"><span data-tour-typing></span><i></i>${icon("plus")}</div><div class="tour-exam-card"><div class="tour-exam-icon">${icon("today")}</div><div><b>${t("English exam")}</b><small>${t("Your next milestone")}</small></div><strong><span data-tour-countdown>14</span><small>${t("days left")}</small></strong></div><div class="tour-exam-track"><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div><div class="tour-exam-note">${icon("check")}<span>${t("Saved. Keep the date in sight.")}</span></div></div>`;
}

export function landingTour() {
  const items = [
    [
      "rhythm",
      "A routine that fits your life.",
      "Choose any days together. Keep the same plan every day, group similar days, or plan a fresh week.",
      "Choose days. Make them yours.",
      "manage",
      [
        "Choose any days together",
        "Add your priorities",
        "Repeat at your own pace",
      ],
    ],
    [
      "floating",
      "Keep focus in the corner.",
      "Open the mini timer while you work in other apps. Resize it, or hide the time when you want fewer distractions.",
      "A small timer. More room to work.",
      "pomodoro",
      [
        "Open the mini timer",
        "Keep working in other apps",
        "Resize it to fit your screen",
      ],
    ],
  ];
  return `<section class="dayx-tour" id="in-action" aria-labelledby="tourTitle"><div class="dayx-section-intro"><div class="landing-eyebrow">02 / ${t("DayX in action")}</div><h2 id="tourTitle">${t("See your day take shape.")}</h2><p>${t("A few simple actions. Everything you need to plan, focus and follow through.")}</p></div>${productShowcase(demoCursor)}<div class="product-companion-heading"><h3>${t("A few thoughtful extras.")}</h3><p>${t("Make the routine yours. Keep your focus close.")}</p></div><div class="product-companions">${items.map(([kind, title, description, caption, route, steps], i) => `<section class="product-story ${i % 2 ? "reverse" : ""}" id="demo-${kind}" aria-labelledby="demo-${kind}-title"><div class="product-story-copy"><div class="landing-eyebrow">0${i + 5} / ${t(caption)}</div><h3 id="demo-${kind}-title">${t(title)}</h3><p>${t(description)}</p><ol>${steps.map((step, index) => `<li><span>0${index + 1}</span>${t(step)}</li>`).join("")}</ol><a href="/${route}" data-enter="${route}">${t("Try it in DayX")}${icon("arrow")}</a></div><div class="product-scene tour-scene companion-scene" data-demo="${kind}" aria-hidden="true">${tourScene(kind)}${demoCursor}</div></section>`).join("")}</div></section>`;
}

export function drawTour(scene, settled, { setText, formatTime, moveCursor }) {
  const el = scene.element,
    kind = el.dataset.demo,
    seconds = (scene.elapsed % 14000) / 1000;
  if (kind === "rhythm") {
    const rest = !settled && seconds >= 7;
    const chosen = rest ? [1, 3, 5, 6] : [0, 2, 4];
    el.querySelectorAll("[data-tour-day]").forEach((day, i) =>
      day.classList.toggle(
        "selected",
        chosen.includes(i) && (settled || seconds >= 1 + i * 0.35),
      ),
    );
    setText(
      el.querySelector("[data-tour-group]"),
      t(rest ? "My rest days" : "My workdays"),
    );
    setText(
      el.querySelector("[data-tour-days]"),
      chosen
        .map((i) => t(["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][i]))
        .join(" · "),
    );
    el.querySelector('[data-tour-routine="work"]').hidden = rest;
    el.querySelector('[data-tour-routine="rest"]').hidden = !rest;
    const cue = rest ? 5 : seconds >= 2 ? 4 : seconds >= 1.4 ? 2 : 0;
    moveCursor(
      scene,
      el.querySelector(`[data-tour-day="${cue}"]`),
      cue,
      !settled && seconds < 10,
      [1, 1.7, 2.4, 7.2].some((n) => seconds >= n && seconds < n + 0.4),
    );
  } else if (kind === "table") {
    const complete = settled
      ? 15
      : Math.min(21, Math.floor(Math.max(0, seconds - 0.8) * 2.3));
    el.querySelectorAll("[data-tour-cell]").forEach((cell, i) =>
      cell.classList.toggle("done", i < complete),
    );
    setText(el.querySelector("[data-tour-total]"), `${complete} / 21`);
    moveCursor(
      scene,
      el.querySelector(`[data-tour-cell="${Math.min(complete, 20)}"]`),
      complete,
      !settled && seconds < 11,
      complete > 0 && seconds < 10,
    );
  } else if (kind === "floating") {
    const open = settled || seconds >= 2.2,
      hidden = !settled && seconds >= 6.2 && seconds < 10.4;
    el.classList.toggle("mini-open", open);
    el.querySelector(".tour-mini-clock").hidden = hidden;
    el.querySelector(".tour-mini-art").hidden = !hidden;
    setText(
      el.querySelector("[data-demo-time]"),
      formatTime(1500 - (settled ? 0 : Math.floor(seconds))),
    );
    const cue = seconds >= 4.7 ? 1 : 0;
    moveCursor(
      scene,
      el.querySelector(cue ? "[data-tour-hide]" : "[data-tour-open]"),
      cue,
      !settled && seconds < 11,
      [2.2, 6.2, 10.4].some((n) => seconds >= n && seconds < n + 0.4),
    );
  } else if (kind === "exams") {
    const name = t("English exam");
    setText(
      el.querySelector("[data-tour-typing]"),
      settled
        ? name
        : name.slice(0, Math.floor(Math.max(0, seconds - 0.6) * 8)),
    );
    el.classList.toggle("exam-saved", settled || seconds >= 3.6);
    setText(
      el.querySelector("[data-tour-countdown]"),
      String(settled || seconds < 7 ? 14 : 13),
    );
    moveCursor(
      scene,
      el.querySelector(".tour-exam-input > .ui-icon"),
      0,
      !settled && seconds >= 2 && seconds < 5.5,
      seconds >= 3.6 && seconds < 4,
    );
  }
}
